import apiClient from 'apiClient';
import { INCOME_TYPES, PatchResponse } from 'modules/cm/api/cases/income/types';
import withCaseErrorMiddleware from '../caseError/withCaseErrorMiddleware';
import { PatchApplicantIncomeResponseData } from '../types';

const PREFIX = '/api/v1/cases';

const incomeUrlResourceNameMap: Map<INCOME_TYPES, string> = new Map<INCOME_TYPES, string>([
  [INCOME_TYPES.INVESTMENT, 'current-investment-incomes'],
  [INCOME_TYPES.RENTAL, 'current-rental-incomes'],
  [INCOME_TYPES.OTHER, 'current-other-incomes'],
  [INCOME_TYPES.FOSTERING, 'current-fostering-incomes'],
  [INCOME_TYPES.MAINTENANCE, 'current-maintenance-incomes'],
  [INCOME_TYPES.BENEFIT, 'current-benefit-incomes'],
]);

export const patchIncome = (
  caseId: string,
  applicantId: number,
  incomeId: number,
  incomeType: INCOME_TYPES,
  field: string,
  value: any,
): PatchResponse => {
  const incomeResourceName = incomeUrlResourceNameMap.get(incomeType);
  if (!incomeResourceName) {
    throw new Error(`Invalid income type: ${incomeType}`);
  }
  return apiClient
    .patch<PatchApplicantIncomeResponseData>(
      `${PREFIX}/${caseId}/applicant/${applicantId}/${incomeResourceName}/${incomeId}`,
      {
        [field]: value,
      },
    )
    .then(withCaseErrorMiddleware);
};
